'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { Button, Icon, Popover, PopoverContent, PopoverTrigger, Separator } from '@repo/ui';
import { Chevron } from '@repo/ui/icons';
import { ChainIcon } from '@repo/web3';
import { useEffect, useState } from 'react';
import ButtonContent from './ButtonContent/ButtonContent';
import { SelectItem } from './SelectItem';
export interface SelectMultipleNetworkProps {
  values: ChainId[];
  isAllSelected: boolean;
  setIsAllSelected: (value: boolean) => void;
  onChange: (value: ChainId[]) => void;
  options?: readonly OptionSelectMultipleNetwork[];
  disabled?: boolean;
  triggerClassName?: string;
}
export interface OptionSelectMultipleNetwork {
  label: string;
  value: ChainId;
  tag?: string;
}
function getSelectedValue(options: readonly OptionSelectMultipleNetwork[], value: string) {
  return options.find(option => String(option.value) === String(value))?.value;
}
export function SelectMultipleNetwork(t0) {
  const $ = _c(41);
  const {
    values,
    isAllSelected,
    setIsAllSelected,
    onChange,
    options,
    disabled,
    triggerClassName
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== open) {
    t1 = [open];
    $[0] = open;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[2] !== isAllSelected || $[3] !== onChange || $[4] !== options || $[5] !== setIsAllSelected || $[6] !== values) {
    t2 = value => {
      const typedValue = getSelectedValue(options ?? [], value);
      if (!typedValue) {
        return;
      }
      if (isAllSelected) {
        setIsAllSelected(false);
      }
      let newSelectedValues;
      if (values.includes(typedValue)) {
        if (values.length === 1) {
          return;
        }
        newSelectedValues = values.filter(v => v !== typedValue);
      } else {
        newSelectedValues = [...values, typedValue];
      }
      onChange(newSelectedValues);
    };
    $[2] = isAllSelected;
    $[3] = onChange;
    $[4] = options;
    $[5] = setIsAllSelected;
    $[6] = values;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleItemClick = t2;
  let t3;
  if ($[8] !== onChange || $[9] !== setIsAllSelected) {
    t3 = () => {
      setIsAllSelected(true);
      onChange([]);
    };
    $[8] = onChange;
    $[9] = setIsAllSelected;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleAllSelected = t3;
  let t4;
  if ($[11] !== isAllSelected || $[12] !== options || $[13] !== values) {
    t4 = isAllSelected ? "All chains" : <ButtonContent values={values} options={options ?? []} />;
    $[11] = isAllSelected;
    $[12] = options;
    $[13] = values;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const t5 = open ? "rotate(180deg)" : "rotate(0deg)";
  let t6;
  if ($[15] !== t5) {
    t6 = <Icon icon={<Chevron className="transition-transform duration-200" style={{
      transform: t5
    }} />} />;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6 || $[19] !== triggerClassName) {
    t7 = <Button variant="secondary" className={triggerClassName}>{t4}{t6}</Button>;
    $[17] = t4;
    $[18] = t6;
    $[19] = triggerClassName;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== disabled || $[22] !== t7) {
    t8 = <PopoverTrigger asChild={true} disabled={disabled}>{t7}</PopoverTrigger>;
    $[21] = disabled;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setOpen(false);
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== handleAllSelected || $[26] !== isAllSelected) {
    t10 = <SelectItem value="all" selected={isAllSelected} onItemClick={handleAllSelected}>All chains</SelectItem>;
    $[25] = handleAllSelected;
    $[26] = isAllSelected;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Separator className="my-xs" />;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== handleItemClick || $[30] !== isAllSelected || $[31] !== options || $[32] !== values) {
    t12 = options?.map(option => <SelectItem key={String(option.value)} value={String(option.value)} icon={<ChainIcon chainId={option.value} className="h-full w-full" />} tag={option.tag} selected={values.includes(option.value) && !isAllSelected} onItemClick={handleItemClick}>{option.label}</SelectItem>);
    $[29] = handleItemClick;
    $[30] = isAllSelected;
    $[31] = options;
    $[32] = values;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t10 || $[35] !== t12) {
    t13 = <PopoverContent align="start" side="bottom" sideOffset={4} onMouseLeave={t9} className="bg-card border-border w-[min(200px,70vw)] overflow-hidden rounded-lg border-[0.5px] p-0 shadow-md"><div className="p-xs max-h-[50svh] overflow-auto">{t10}{t11}{t12}</div></PopoverContent>;
    $[34] = t10;
    $[35] = t12;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== open || $[38] !== t13 || $[39] !== t8) {
    t14 = <Popover open={open} onOpenChange={setOpen}>{t8}{t13}</Popover>;
    $[37] = open;
    $[38] = t13;
    $[39] = t8;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  return t14;
}
function _temp() {
  const body = document.body;
  body.removeAttribute("data-scroll-locked");
}